module.exports = __webpack_public_path__ + "img/icon-arrow-warning.5cf6e635.svg";